export const INVOICE_DETAILS = {
  address: {
    postalCode: '00-732 Warsaw, Poland',
    street: '8/10 Czerska Street',
  },
  companyName: 'Yieldbird Sp. z o.o.',
  email: 'invoices@yieldbird.com',
  vat: 'PL6792996939',
} as const
